import { FindBrandModelNumber } from '@us-registration/util-models';

export const modelNumberLocation: FindBrandModelNumber = {
  AMANA: [
    {
      product: 'COOKTOP',
      content: [
        'Located underneath the burner box. This should be visible once you flip over the cooktop.',
      ],
      image: ['COOKTOP'],

      missingAppliances: 'Stand Mixer\r',
    },
    {
      product: 'DISHWASHER',
      content: [
        'Located in front of the door seal, on the top left-hand corner of the tub.',
      ],
      image: ['DISHWASHER'],
    },

    {
      product: 'DRYER',
      content: [
        'Top load dryer, located inside the door, on the upper left-hand side of the front panel.',
        'For a front load located along the bottom of the shroud, right in front of the lint screen.',
      ],
      image: ['DRYER'],
    },
    {
      product: 'MICROWAVE',
      content: [
        'Located on the right-hand edge of the interior wall. This should be visible once you open the door.',
      ],
      image: ['MICROWAVE'],
    },
    {
      product: 'OVEN',
      image: ['WALLOVEN'],
    },
    {
      product: 'RANGE HOODS',
      content: [
        'Located on the left-hand side of the rear wall, underneath the hood.',
      ],
    },
    {
      product: 'RANGE',
      image: ['RANGE1', 'RANGE2'],
    },
    {
      product: 'REFRIGERATOR',
      image: ['REFRIGERATOR'],
    },
    {
      product: 'WASHER',
      content: [
        'Top load washer, located above the rear of the wash basket. This should be visible once you open the lid.',
        'Front load washer, Located inside the door, along the outer left edge.',
      ],
      image: ['WASHER'],
      comments: 'Top load washer',
    },
  ],
  WHIRL: [
    {
      product: 'COMPACTOR',
      content: ['Inside","On rim'],
    },
    {
      product: 'COOKTOP',
      content: ['Inside the burner box', 'Underneath on the bottom'],
      image: ['COOKTOP'],
    },

    {
      product: 'DISHWASHER',
      content: [
        'Upper left corner of the frame',
        'Underside of the control panel',
      ],
      image: ['DISHWASHER'],
    },
    {
      product: 'DISPOSERS',
      content: ['On the bottom'],
    },
    {
      product: 'DRYER',
      content: [
        'On the upper left of the cabinet (in the back)',
        'Inside on the back frame (door open)',
        'Inside the door',
        'Behind the access panel (gas dryers only)',
      ],
      image: ['DRYER'],
    },
    {
      product: 'MICROWAVE',
      content: [
        'Back of the microwave',
        'Upper left of the cavity',
        'Left side of the control panel (door open)',
        'Right side of the base frame (door open)',
        'Front of the base frame (door open)',
      ],
      image: ['MICROWAVE'],
    },
    {
      product: 'OVEN',
      content: ['Lower left side of the frame (door open)'],
      image: ['WALLOVEN'],
      comments: 'wall oven',
    },
    {
      product: 'RANGE',
      content: ['Inside the burner box', 'Underneath on the bottom'],
    },

    {
      product: 'REFRIGERATOR',
      content: [
        'Top left side of the food compartment',
        'Top front of the food compartment',
        'Food liner (upper right side of the crisper pan)',
      ],
      image: ['REFRIGERATOR'],
    },
    {
      product: 'WASHER',
      content: [
        'On the back,behind the control panel',
        'Inside the washer lid,right bottom corner',
        'On the back on the baseframe to the left',
      ],
      image: ['WASHER'],
    },
  ],
  KHAID: [
    {
      product: 'BLENDER',
      content: ['Beneath the blender on the base of the unit'],
      missingAppliances:
        'Immersion Blenders:","Inlaid on the shaft, below the handle","KITCHENAID,COFFEE GRINDER,On the bottom of the grinder\'s base","KITCHENAID,COFFEE MAKER,,,,","KITCHENAID,COMBO MICROWAVES,,,,","KITCHENAID,COMPACTOR,On the inside of the compactor\'s sliding door,,,","KITCHENAID,"COOKTOP',
    },
    {
      product: 'COOKTOP',
      content: ["On the cooktop's liner, beneath the burners"],
      image: ['COOKTOP'],
    },
    {
      product: 'DISHWASHER',
      content: ["On the left edge of the dishwasher's door"],
      image: ['DISHWASHER'],
    },
    {
      product: 'DISPOSERS',
      image: ['FOODWASTE'],
    },
    {
      product: 'DRYER',
      content: ['On the dryer lid or door'],
      image: ['DRYER'],
    },
    {
      product: 'FOOD PROCESSOR',
      content: [
        'Beneath the push-button controls on the base of the food processor',
      ],
    },
    {
      product: 'ICE MAKER',
      content: ['Inside the ice maker, beneath the lid'],
    },
    {
      product: 'MICROWAVE',
      content: ['Inside the door'],
      image: ['MICROWAVE'],
    },
    {
      product: 'MIXER',
      content: [
        "On the bottom of the unit's base, adjacent to the accessory holders",
        "On the bottom of the unit's base and back",
      ],
    },
    {
      product: 'STAND MIXER',
      content: ["On the bottom of the unit's base and back"],
    },
    {
      product: 'HAND MIXER',
      content: [
        "On the bottom of the unit's base, adjacent to the accessory holders",
      ],
    },
    {
      product: 'OVEN',
      content: ['Inside the door'],
      image: ['WALLOVEN'],
    },

    {
      product: 'RANGE',
      content: [
        'On the front, inside edge of the hood or vent',
        "Inside the oven's door",
      ],
      image: ['RANGE1', 'RANGE2'],
    },

    {
      product: 'REFRIGERATOR',
      content: ['Inside the refrigerator, on the left wall'],
      image: ['REFRIGERATOR'],
    },

    {
      product: 'SINK PRODUCTS',
      content: ['On the basin, beneath the countertop'],
    },

    {
      product: 'TOASTER',
      content: [
        "On the bottom of the unit's base, adjacent to the electrical cord",
      ],
    },

    {
      product: 'WARMING DRAWER',
      content: ["On the inside of the warming drawer's face"],
    },
    {
      product: 'WASHER',
      content: ["On the washer's lid or door"],
      image: ['WASHER'],
    },

    {
      product: 'WATER',
      content: [
        'Beneath the counter, where the dispenser is mounted into the sink',
      ],
    },
    {
      product: 'WINE COOLER',
      content: ['Inside the wine cellar, on the left wall'],
    },
  ],
  MYTAG: [
    {
      product: 'COOKTOP',
      content: ['Inside the burner box', 'Underneath on the bottom'],
      image: ['COOKTOP'],
    },
    {
      product: 'DISHWASHER',
      content: [
        'Upper left corner of the frame',
        'Underside of the control panel',
      ],
      image: ['DISHWASHER'],
    },
    {
      product: 'DISPOSERS',
      content: ['On the bottom'],
    },
    {
      product: 'DRYER',
      content: [
        'Inside left rear corner of washer top (door open)',
        'On cabinet, inside right rear corner of washer top (door open)',
      ],
      image: ['DRYER'],
    },
    {
      product: 'DRYER',
      content: [
        'On the upper left of the cabinet (in the back)',
        'Inside on the back frame (door open)',
        'Inside the door',
        'Behind the access panel (gas dryers only)',
        'Inside left rear corner of washer top (door open)',
        'On cabinet, inside right rear corner of washer top (door open)',
      ],
      image: ['DRYER'],
    },
    {
      product: 'MICROWAVE',
      content: [
        'Back of the microwave',
        'Upper left of the cavity, Left side of the control panel (door open)',
        'Right side of the base frame (door open)',
        'Front of the base frame (door open)',
      ],
      image: ['MICROWAVE'],
    },
    {
      product: 'OVEN',
      content: ['Lower left side of the frame (door open)'],
      image: ['WALLOVEN'],
      comments: 'Wall oven',
    },
    {
      product: 'RANGE',
      content: ['Inside the burner box', 'Underneath on the bottom'],
      image: ['RANGE1', 'RANGE2'],
    },
    {
      product: 'REFRIGERATOR',
      content: [
        'Top left side of the food compartment',
        'Top front of the food compartment',
        'Food liner (upper right side of the crisper pan)',
      ],
      image: ['REFRIGERATOR'],
    },
    {
      product: 'WASHER',
      content: [
        'On the back,behind the control panel',
        'Inside the washer lid,right bottom corner',
        'On the back on the baseframe to the left',
        'Inside left rear corner of washer top (door open)',
        'On cabinet, inside right rear corner of washer top (door open)',
      ],
      image: ['WASHER'],
    },
  ],
};
